import React, {Component} from 'react'
import PropTypes from 'prop-types';

import Label from '../label'
import List from './list'
import Search from '../form/form-search'
import Button from '../button/button'

import './list-checked.styl'
class ListChecked extends Component {
    static propTypes = {
        label: PropTypes.string,
        printable: PropTypes.bool,
        disabled: PropTypes.bool,
        className: PropTypes.string,
        placeholder: PropTypes.string,
        collection:  PropTypes.arrayOf(
            PropTypes.shape({
                label: PropTypes.string.isRequired
            })
        ).isRequired,
        request: PropTypes.func,
        onSelect: PropTypes.func
    }
    static defaultProps = {
        collection: []
    }

    constructor(props) {
        super(props);
        this.state = {
            collection: props.collection
        };
        this.rm = this.rm.bind(this)
    }

    select(value){
        let {collection} = this.state;
        let inside = collection.find( e => e.id === value.id)
        !inside && collection.push(value);
        this.setState({collection})
        this.props.onSelect({collection})
    }

    rm(index){
        return e => {
            let {collection = []} = this.state;
            collection.splice(index, 1);
            this.setState({collection})
            this.props.onSelect({collection})
        }
    }

    request(value){
        return this.props.request({value})
    }

    UNSAFE_componentWillReceiveProps(nextProps, nextState) {
        this.setState(nextProps)
    }

    render() {
        const { printable=true } = this.props
        if(!printable){
            return <div className="hide"></div>
        }
        let { label='', placeholder, disabled=false, className=false } = this.props
        let { collection } = this.state;
        let list = [];

        collection.forEach((element, index) => list.push(<li className="name" key={element.label + '-' + index}>
            <Label>{element.label}</Label>
            {!disabled && <Button onClick={this.rm(index)} icon="cross"/>}
        </li>))

        className = 'form list-checked' + (className ? ' ' + className : '')

        return <div className={className}>
            {!disabled && <Search label={label} onSelect={this.select.bind(this)} onChange={this.request.bind(this)} placeholder={placeholder} />}
            {disabled && <Label>{label}</Label> }
            <div className={'list-checked-content' + (disabled ? ' disabled' : '')}>
                <List collection={list} />
            </div>
        </div>
    }
}

export default ListChecked
